import type { Document } from "@contentful/rich-text-types";

import { createUseQueryEntry } from "./client";

export interface ContentfulLeftRightBlockFields {
	title: string;
	titleHighlightText: string;
	subtitle: string;
	leftContent: Document;
	rightContent: Document;
}
export const CONTENTFUL_PLAYGROUND_WELCOME_PAGE_INTEGRATIONS_LEFT_RIGHT_BLOCK = "63pO3bGjQTW0HsHagXD0Ew";
export const useQueryPlaygroundWelcomePageTryFreeBlock = createUseQueryEntry<ContentfulLeftRightBlockFields>(
	CONTENTFUL_PLAYGROUND_WELCOME_PAGE_INTEGRATIONS_LEFT_RIGHT_BLOCK,
);
